// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5s-6";
export var headerCell = "_5s-2";
export var rowWrapper = "_5s-4";
export var stickyAggregationCell = "_5s-a";
export var stickyAggregationRow = "_5s-7";
export var stickyColumnCell = "_5s-9";
export var stickyColumnHeaderCell = "_5s-8";
export var table = "_5s-1";
export var virtualRowWrapper = "_5s-5";
export var virtualTableContainer = "_5s-0";
export var white = "_5s-3";